// src/App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, Box } from '@mui/material';
import theme from './theme';
import { CartProvider } from './CartContext';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Watermark from './components/Watermark';
import AuthPage from './components/AuthPage';
import Menu from './components/Menu';
import Cart from './components/Cart';
import Payment from './components/Payment';
import PaymentSuccess from './components/PaymentSuccess';
import PastOrders from './components/PastOrders';
import useIdleLogout from './utils/useIdleLogout';
import PaymentCallback from './components/PaymentCallback';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    localStorage.getItem('authenticated') === 'true'
  );

  useEffect(() => {
    localStorage.setItem('authenticated', isAuthenticated);
  }, [isAuthenticated]);

  // Auto-logout after 30min idle
  useIdleLogout(setIsAuthenticated, 30 * 60 * 1000);

  return (
    <ThemeProvider theme={theme}>
      <CartProvider>
        <BrowserRouter>
          <Navbar
            isAuthenticated={isAuthenticated}
            setAuth={setIsAuthenticated}
          />

          {/* Watermark behind content */}
          <Watermark />

          <Box
            sx={{
              pt: { xs: '56px', sm: '64px' },
              pb: { xs: '80px', sm: '80px' }
            }}
          >
            <Routes>
              <Route
                path="/"
                element={isAuthenticated ? <Menu /> : <Navigate to="/auth" />}
              />
              <Route
                path="/auth"
                element={<AuthPage setAuth={setIsAuthenticated} />}
              />
              <Route
                path="/cart"
                element={isAuthenticated ? <Cart /> : <Navigate to="/auth" />}
              />
              <Route
                path="/payment"
                element={isAuthenticated ? <Payment /> : <Navigate to="/auth" />}
              />
              <Route
                path="/payment-success/:id"
                element={
                  isAuthenticated ? (
                    <PaymentSuccess />
                  ) : (
                    <Navigate to="/auth" />
                  )
                }
              />
              <Route path="/payment/callback" element={<PaymentCallback />} />
              <Route
                path="/past-orders"
                element={
                  isAuthenticated ? <PastOrders /> : <Navigate to="/auth" />
                }
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Box>

          <Footer />
        </BrowserRouter>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
